import React from 'react'

import { TAccountActivationStatus } from '@sga/shopify-payments-types'

import { Banner, Collapsible, Stack, TextContainer, Toast } from '@shopify/polaris'

import { useSegmentLabel } from '../hooks/useSegmentLabel'
import { useShopifyActivation } from '../hooks/useShopifyActivation'
import { getTranslation } from '../util/getTranslation'

type TProps = {
  CredentialsForm: React.FunctionComponent
  status: TAccountActivationStatus
  setStatus: (status: TAccountActivationStatus) => any
}

export function ActivationCard({ CredentialsForm, status }: TProps) {
  const activation = useShopifyActivation()

  const segmentLabel = useSegmentLabel()

  // if (status === 'active') {
  //   // Final state, nothing to do here.
  //   return null
  // }

  return (
    <>
      <Collapsible id="new" open={status === 'new'}>
        <Stack>
          <Banner status="info">
            <p>
              {getTranslation('activation.guide_intro', { segment: segmentLabel })}{' '}
              {getTranslation('activation.guide_instructions')}
            </p>
          </Banner>
          <CredentialsForm />
        </Stack>
      </Collapsible>
      <Collapsible id="verified" open={status !== 'new'}>
        <Banner
          status="success"
          action={activation.action}
          title={getTranslation('activation.details_verified', { segment: segmentLabel })}
        >
          <TextContainer>
            <p>{getTranslation('activation.activation_required')}</p>
            <p>{getTranslation('activation.settings_recommendation')}</p>
          </TextContainer>
        </Banner>
      </Collapsible>
      {activation.status === 'success' && (
        <Toast content={getTranslation('activation.redirecting')} onDismiss={activation.dismiss} />
      )}
      {activation.status === 'failure' && (
        <Toast content={getTranslation('activation.activation_failed')} error onDismiss={activation.dismiss} />
      )}
    </>
  )
}
